<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>被犬启发的人机交互意图预测框架</h1>
        </div>
        <div class="picture">
          <img src="../assets/project15_1.jpg.webp" />
        </div>
        <div class="paper_published">
          Gong, Q.*, Chen, C., Wang, K., Li, C., Qin, Y., Qiao, X., Zou, N. (2026). From Service Dogs to Robots: A Bio-inspired Framework for Intuitive Intent Prediction in Mixed Reality, International Journal of Human–Computer Interaction, 1-19
        </div>

        <div class="abstract">
          本项目提出一个受人类与服务犬协作范式启发的交互意图预测框架，目标是提升人与四足机器人的交互直觉性与可用性。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_2.jpeg.webp" />
          <br /><br /><img src="../assets/project15_3.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">1 引言</div>
        <div class="text">
          四足机器人快速发展，应用场景从军事、搜救逐步转向家庭服务，但传统人机交互方式过度依赖单模态语音或复杂指令，交互不够直观，用户体验不佳。本研究受人类与服务犬经长期协同进化形成的自然交互范式启发，将这种仿生交互模式迁移到人与四足机器人的控制中，拟借助混合现实（MR）技术搭建交互环境，基于贝叶斯方法构建多模态意图预测模型，解决现有人机交互系统操作效率低、情感共鸣不足、易用性差的问题，为服务机器人提供可扩展、高直觉性的控制框架。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">2 方法</div>
        <div class="text">
          首先通过对服务犬主人的访谈与视频观察开展预实验，提炼核心交互规则与行为特征；随后基于 HoloLens 2 与虚拟服务犬搭建 MR 数据采集环境，招募 37 名有效被试完成初识、自助、助人、行为管控四类场景的交互任务，采集语音、手势、体态等多模态数据并进行处理，对特征编码与筛选后保留三大核心模态；采用极大似然估计与拉普拉斯平滑构建分层贝叶斯网络意图预测模型，模型取得良好的 Top-3 预测准确率；最后将模型部署到基于 MR 的机器人控制系统（IIP）中，招募 32 名新被试，与纯语音（SI）、标准语音 - 手势（SGI）系统进行组内对照实验，从操作效率、情绪体验（PAD 量表）、系统易用性（SUS 量表）三方面开展评估。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_4.jpeg.webp" />
          <br /><br /><img src="../assets/project15_5.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_6.jpeg.webp" />
          <br /><br /><img src="../assets/project15_7.jpeg.webp" />
          <br /><br /><img src="../assets/project15_8.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">3 结论</div>
        <div class="text">
          本研究验证了将人类 - 服务犬交互范式迁移到四足机器人控制的可行性，所提出的基于贝叶斯的多模态意图预测模型（IIP）在操作效率、用户情绪体验、系统易用性上均显著优于传统纯语音与标准多模态界面；MR 技术的使用降低了实验开发成本，提供了第一人称沉浸式交互视角。研究在理论上为人机交互提供了全新的仿生设计逻辑，在实践上让非专业用户可直观操控机器人。研究局限在于样本量偏小且偏向年轻群体、仅在虚拟环境验证，未来将扩大样本、在实体机器人上测试，并结合深度学习升级模型，进一步提升交互系统性能。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project15Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}

.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
